import { GA4InitConfig } from '@mp-commons/config/GA4InitConfig.js';
import { AdErrorStruct, PlayerAdEvent } from "@mp-commons/modules/ads/PlayerAdEvent.js";
import { CP_EmbedType } from "@mp-commons/modules/ads/adcall/CustomParams.js";
import { MediaEvent, MediaProgressEvent, isMediaCompleteEvent, isMediaImpressionEvent, isMediaStartedEvent } from "@mp-commons/modules/events/PlayerEvent.js";
import { GA4VideoBasicCollector } from "@mp-commons/modules/stats/collectors/GA4VideoBasicCollector.js";
import { DEFAULT_AD_EVENTS_TO_TRIGGER, PreFilteredEventMapper } from "@mp-commons/modules/stats/mappers/PreFilteredEventMapper.js";
import { VideoInfoRawData } from '@mp-commons/model/video/VideoInfo.js';
import { GA4MapperConfig } from '@mp-commons/modules/stats/collectors/GA4MediaBasicCollector.js';

class GA4MegarideCollector extends GA4VideoBasicCollector {

    constructor(cfg: GA4InitConfig,
        win: WindowProxy,
        private embedType: CP_EmbedType) {
            super({
                ...cfg,
                forcePage:null,
                eventNamespace: "ymvod"
            },win)
    }

    protected mangleEventData(eventName: string, inputData: { [k: string]: string | number; }, info?: VideoInfoRawData): { [k: string]: string | number; } {
        const data = inputData?inputData:{};
        data.embed_type = this.embedType;
        return data;
    }
    

    public trackAdError(info: VideoInfoRawData, error: AdErrorStruct): Promise<void> {
        return this.trackEvent("aderror",{
            error_code: error.errorCode,
            ad_unit: error.adunit?error.adunit:"unspecified_unit"
        });
    }


    public trackAdEvent(info: VideoInfoRawData, unit: string, action: string): Promise<void> {
        return this.trackEvent("aderror",{
            action: action,
            ad_unit: unit
        });
    }

    

}


export class GA4Mapper extends PreFilteredEventMapper<VideoInfoRawData> {
    
    
    
    private ga4: GA4MegarideCollector;
    

    constructor(private window: Window,
                private embedType: CP_EmbedType, 
                private readonly config: GA4MapperConfig) {
        super({
            media: config.media,
            aderrors: config.aderrors,
            adevents: config.adevents?DEFAULT_AD_EVENTS_TO_TRIGGER:[],
            progressMilestones: config.media_progress?[25,50,75,90]:[],
        });
        this.ga4 = new GA4MegarideCollector(config,this.window,this.embedType);
        
    }



    protected onAdError(errorStruct: AdErrorStruct, adjustedLabel?: string,adjustedEventLabel?: string): void {
        this.ga4.trackAdError(null,{
            ...errorStruct,
            adunit: adjustedLabel?adjustedLabel:errorStruct.adunit
        });
    }

    protected onAdEvent(evt: PlayerAdEvent, adjustedLabel?: string,adjustedEventLabel?: string): void {
        this.ga4.trackAdEvent(null,adjustedLabel,adjustedEventLabel);
    }

    protected onMediaProgress(progEvent: MediaProgressEvent, corrected_percentage: number): void {
        this.ga4.mediaProgress(progEvent.info,corrected_percentage);
    }
    protected onMediaEvent(evt: MediaEvent<VideoInfoRawData>): void {
        if(isMediaStartedEvent(evt)) this.ga4.mediaStarted(evt.info)
        else if(isMediaCompleteEvent(evt)) this.ga4.mediaCompleted(evt.info);
        else if(isMediaImpressionEvent(evt)) this.ga4.mediaImpression(evt.info);
        
    }





}